import getLocalString from "constants/Localization";
import {
  GetOrganizationEmailIdentityDocument,
  useToggleOrganizationEmailIdentityMutation,
} from "generated/graphql";
import useGlobalMessage from "hooks/notifications/useGlobalMessage";
import { useCallback } from "react";

export default function useToggleOrganizationEmailIdentity() {
  const { show } = useGlobalMessage();
  const [toggle, { loading }] = useToggleOrganizationEmailIdentityMutation({
    refetchQueries: [{ query: GetOrganizationEmailIdentityDocument }],
  });

  const handleToggle = useCallback(
    async (enabled: boolean) => {
      try {
        await toggle({ variables: { enabled } });
      } catch {
        show({
          message: getLocalString("emailIdentity.toggle-failure"),
          options: { variant: "error" },
        });
      }
    },
    [toggle, show]
  );

  return [handleToggle, { loading }] as const;
}
